import { Box, colors, Typography } from "@mui/material";
import { ReactNode } from "react";

// One heading for every section that closes a listing page, so about, buying guide
// and faq read as a set instead of three different treatments.
export default function PlpSectionHeading({ children }: { children: ReactNode }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: { xs: 3, lg: 4 } }}>
            <Typography component="h2" sx={{
                m: 0,
                color: colors.grey[800],
                // One step above the largest heading the bodies below can contain -- the
                // editor's own h2 lands at 20 after PlpDescription shifts it down -- so the
                // section title still leads without shouting over its own content.
                fontSize: { xs: 20, lg: 22 },
                fontWeight: 600,
            }}>
                {children}
            </Typography>
            <Box sx={{ flex: 1, height: '1px', bgcolor: colors.grey[200] }} />
        </Box>
    );
}
